import Vue from 'vue';
import Router from 'vue-router';

import _ from 'lodash';

import TvRoutes from './routes/tv';
// import VidoeRoutes from './routes/theme';

import store from './vuex/store';

Vue.use(Router);

const routes = TvRoutes;
// const routes = TvRoutes.concat(VidoeRoutes);

const router = new Router({
  mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'history',
  // mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  const meta = _.pick(to.meta, ['title', 'description']);
  meta.path = to.path === '/landing' ? '/' : to.path;
  store.dispatch('meta/updateMeta', meta);

  // console.log('router.beforeEach', to, from, next);

  // console.log(store.state.nav.nav);

  // Bus.$emit('init_gui');

  next();
});

export default router;
